// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

// Send custom event to Google Analytics
export const sendGAEvent = (
  eventName: string,
  parameters: Record<string, any> = {},
) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, {
      ...parameters,
      timestamp: new Date().toISOString(),
    });
  }
};

// Track page visits
export const trackPageVisit = (
  pageName: string,
  additionalData: Record<string, any> = {},
) => {
  sendGAEvent("page_visit", {
    page_name: pageName,
    page_path: window.location.pathname,
    ...additionalData,
  });
};

// Track user interactions
export const trackUserInteraction = (
  action: string,
  category: string,
  label?: string,
  value?: number,
) => {
  sendGAEvent("user_interaction", {
    action,
    category,
    label,
    value,
  });
};

// Track feature usage
export const trackFeatureUsage = (
  featureName: string,
  details: Record<string, any> = {},
) => {
  sendGAEvent("feature_usage", {
    feature_name: featureName,
    ...details,
  });
};

// Track habit-related events
export const trackHabitEvent = (
  action: string,
  habitId?: string,
  details: Record<string, any> = {},
) => {
  sendGAEvent("habit_event", {
    action,
    habit_id: habitId,
    ...details,
  });
};

// Track todo-related events
export const trackTodoEvent = (
  action: string,
  todoId?: string,
  details: Record<string, any> = {},
) => {
  sendGAEvent("todo_event", {
    action,
    todo_id: todoId,
    ...details,
  });
};

// Track tracker value events
export const trackTrackerEvent = (
  trackerName: string,
  trackerValue: string | number | boolean,
  userId?: string,
  details: Record<string, any> = {},
) => {
  sendGAEvent("tracker-event", {
    tracker_name: trackerName,
    tracker_value: trackerValue,
    user_id: userId,
    ...details,
  });
};

// Track navigation events
export const trackNavigation = (
  from: string,
  to: string,
  method: string = "click",
) => {
  sendGAEvent("navigation", {
    from_page: from,
    to_page: to,
    navigation_method: method,
  });
};

// Track successful login — uses GA4 recommended event name "login"
export const trackLoginEvent = (username?: string) => {
  sendGAEvent("login", {
    method: "email",
    username,
  });
};

// Track successful registration — uses GA4 recommended event name "sign_up"
export const trackRegisterEvent = (username?: string) => {
  sendGAEvent("sign_up", {
    method: "email",
    username,
  });
};
